import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { RoutePathname } from '@as-react/common-types';
import { WarningFillIcon } from '@yonderland/andes-icons';
import { Box, Icon, Stack, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { makeGetBasketLockState } from '../../redux/basket/selectors/BasketSelector';
import { NotificationMessage } from './NotificationMessage';
const CONTENT_MAX_WIDTH = 1336;
export const LockedBasketNotificationMessage = () => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const { root } = useAemConfig();
    const isBasketLocked = useSelector(makeGetBasketLockState());
    if (!isBasketLocked)
        return null;
    return (_jsx(NotificationMessage, { children: _jsx("div", { "data-qa": "locked_basket_notification", children: _jsx(Box, { backgroundColor: "warning-bg", paddingBlock: "4", paddingInline: { base: '3', lg: '8' }, children: _jsx(Stack, { justify: { base: 'start', lg: 'center' }, children: _jsx("div", { style: { maxWidth: CONTENT_MAX_WIDTH, width: '100%' }, children: _jsxs(Stack, { direction: "row", align: "center", gap: "3", children: [_jsx(Box, { flex: { shrink: 0 }, children: _jsx(Icon, { source: WarningFillIcon, color: "warning" }) }), _jsxs(TextAlpha, { children: [t('basket.locked.notification.message'), ' ', _jsx(Link, { href: `${root}buy.html/${RoutePathname.PAYMENT}`, children: t('basket.locked.notification.link') })] })] }) }) }) }) }) }));
};
